import { LinearProgress } from '@pets-ui/LinearProgress/LinearProgress'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'
import { getRemainingQuantity } from './getRemainingQuantity'

const styles = stylex.create({
  progress: {
    backgroundImage: 'linear-gradient(90deg, #FFC700 0%, #FF5353 100%)',
  },
})

export interface CouponListItemProgressProps {
  maxUsageLimit: number
  currentUsageCount: number
}

export const CouponListItemProgress = (props: CouponListItemProgressProps) => {
  const { maxUsageLimit, currentUsageCount } = props
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })
  const remaining = maxUsageLimit - currentUsageCount
  const remainingQuantity = getRemainingQuantity(maxUsageLimit, remaining)
  const getRemainingText = () => {
    if (remainingQuantity === 0) return t('cartUi.remainNone', { defaultValue: '剩餘數量 0' })
    if (remainingQuantity) return t('cartUi.remainLeft', { quantity: remainingQuantity, defaultValue: '剩餘數量 < {{quantity}}' })
    return undefined
  }
  const remainingText = getRemainingText()
  const value = Math.floor(currentUsageCount / maxUsageLimit * 100)

  if (maxUsageLimit === 0) return null

  return (
    <VStack gap={1}>
      <LinearProgress variant="determinate" value={value} xStyles={{ bar1: styles.progress }} />
      {remainingText && (
        <Text variant="tiny" color={colors.grey500}>
          {t('cartUi.usageStatus', {
            defaultValue: '已使用 {{usage}}, {{remainingText}}',
            usage: `${value}%`,
          })}
          {remainingText}
        </Text>
      )}
    </VStack>
  )
}
